import i18n from "../../i18n";

export interface MultiDialogType {
  open: boolean;
  type: "document_to_show" | "selected_documents";
}

export const defaultCollectionsTypes = [
  "__favorites",
  "__read_later",
  i18n.t("favorites"),
  i18n.t("read_later"),
];

export const DragTypes = {
  COLLECTION: "collection",
  TRASH: "trash",
  DOCUMENT: "document",
};
